/**
 * 视频监控 — 与运维笔记 log.ipynb（景洪海康+NVR 萤石接入 / 邻水通道情况）一致。
 * 播放地址：萤石开放平台 H5，非自建服务器推流。
 * NVR 本地加密密钥、管理员密码等仅限机房/萤石后台使用，禁止写入前端。
 */

/** 萤石开放平台 Web 播放（与设备上云后的 ezopen 一致） */
export const YS7_IFRAME_PLAYER = 'https://open.ys7.com/ezopen/h5/iframe';

/** 笔记中的 AWS IoT 终端（设备数传/运维 ping 用，与网页视频 iframe 无关） */
export const AWS_IOT_ENDPOINT_HOST = 'ahww2wnnmmzrr.ats.iot.cn-north-1.amazonaws.com.cn';

/**
 * 开放平台 accessToken（按设备/应用在萤石云控制台获取，需定期刷新则改后端下发）。
 */
export const YS7_ACCESS_TOKENS = {
  /** 景洪 NVR */
  jinghong: 'at.b073tael7trxklqocqtb18nx76m982p9-3rbqk4rm8g-0e9qpom-fqiiljfux',
  /** 邻水 NVR */
  linshui: 'at.b073tael7trxklqocqtb18nx76m982p9-3rbqk4rm8g-0e9qpom-fqiiljfux',
};

export const JINGHONG_DEVICE_SERIAL = 'AW8668828';

/** 笔记：景洪 12 路 */
export const JINGHONG_CHANNELS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];

export const LINSHUI_DEVICE_SERIAL = 'K70260080';

/**
 * 邻水现场电脑（运维笔记/内网登记）— 私网地址，只在 192.168.2.0/24 内可直连。
 * 公网浏览器、本地 npm 打开的网页都不能直接用这个 IP 拉监控；网站播放仍走萤石（设备序列号见上）。
 */
export const LINSHUI_SITE_LAN = Object.freeze({
  ipv4: '192.168.2.164',
  netmask: '255.255.255.0',
});

/**
 * 邻水：1、3、10 接入；2、5 笔记载无法接入（仅占位提示）
 */
export const LINSHUI_LIVE_CHANNELS = ['1', '3', '10'];
export const LINSHUI_OFFLINE_CHANNELS = ['2', '5'];
